export const locales = {
	tooltip: 'Texte copié !'
};
